var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"inputField",attrs:{"label":_vm.label,"rules":_vm.rules,"placeholder":_vm.placeholder,"outlined":_vm.outlined,"dense":_vm.dense,"readonly":_vm.readonly,"value":_vm.formattedValue},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }